module.exports = __webpack_public_path__ + "media/newstyle/images/icon-play-94e5f6ca1f47fcdb073dd6409e0ef6de.svg";